<template>
	<div class="view view--public public">
		<PublicHeader />
		<RouterView name="Content" />
		<PublicFooter />
	</div>
</template>

<script>
import { useMiscStore } from '@/lib/store/misc'
import { useHead } from '@unhead/vue'

import Sidebar from '@/components/Sidebar.vue'
import PublicFooter from '@/components/PublicFooter.vue'
import PublicHeader from '@/components/PublicHeader.vue'

export default {
	name: 'ViewPublic',
	components: {
		Sidebar,
		PublicFooter,
		PublicHeader,
	},
	data: () => ({

	}),
	setup() {
		useHead({
			script: [
				{
					src: `https://www.googletagmanager.com/gtag/js?id=${import.meta.env.VITE_GA_ID}`,
					async: true,
				},
				{
					innerHTML: `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments); }gtag('js', new Date()); gtag('config', '${import.meta.env.VITE_GA_ID}'); `
				}
			]
		})

		return {
			miscStore: useMiscStore(),
		}
	},
	computed: {
		miscError() {
			return this.miscStore.error
		},
		miscNotice() {
			return this.miscStore.notice
		},
		guidelineSrc() {
			return this.miscStore.guidelineSrc
		},
	},
	methods: {

	},
	watch: {
		miscError(newVal) {
			if (newVal) {
				this.$notice.show(`ERROR: ${newVal}`)
			}
		},
		miscNotice(newVal) {
			if (newVal) {
				this.$notice.show(newVal)
			}
		},
	}
}
</script>

<style scoped lang="scss">
.public {
	display: grid;
	grid-template-rows: 80px 4px 1fr;
	min-height: 100svh;
	position: relative;

	background:
		linear-gradient(217deg, rgba(43, 167, 255, 0.622), rgba(255,0,0,0) 70.71%),
		linear-gradient(127deg, rgba(192, 201, 227, 0.4), rgba(0,255,0,0) 70.71%),
		linear-gradient(336deg, rgba(5, 52, 170, 0.509), rgba(0,0,255,0) 70.71%),
		linear-gradient(87deg, rgba(77, 205, 156, 0.209), rgba(0,0,255,0) 70.71%),
		#ffffff;
	background-size: cover;
}

.nav {
	border-bottom: 1px solid var(--color--divider);
	column-gap: 2rem;
	display: grid;
	list-style-type: none;
	grid-template-columns: auto auto auto;
	margin: 0;
	padding: 0.5rem 2rem;
}
</style>
